module.exports = __webpack_public_path__ + "media/music.4a52f8a1.mp3";